import { useState } from 'react';
import InitFilters from '../constants/InitFiltering';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [filters, setFilters] = useState(InitFilters());
  const [isRequestDialog, setIsRequestDialog] = useState(false);
  const [isRequestDuplicate, setIsRequestDuplicate] = useState(false);
  const [isRequestDuplicateConfirm, setIsRequestDuplicateConfirm] = useState(false);
  const [isRequestPhysicalCard, setRequestPhysicalCard] = useState(false); // درخواست چاپ فیزیکی
  const [isRequestBlock, setIsRequestBlock] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [reasonDuplicate, setReasonDuplicate] = useState('CardLoss');
  const [isLoadingAdressPhysicalCard, setLoadingAdressPhysicalCard] = useState(false);
  const [imprestDetails, setImprestDetails] = useState(null);
  const [page, setPage] = useState(0);

  const [actionActiveBonCartObj, setActionActiveBonCartObj] = useState({
    isShowDialog: false,
    step: 1,
  });

  return {
    loading, setLoading,
    filterParams, setFilterParams,
    size, setSize,
    filters, setFilters,
    isRequestDialog, setIsRequestDialog,
    isRequestDuplicate, setIsRequestDuplicate,
    isRequestDuplicateConfirm, setIsRequestDuplicateConfirm,
    isRequestPhysicalCard, setRequestPhysicalCard,
    selectedRow, setSelectedRow,
    isRequestBlock, setIsRequestBlock,
    actionLoading, setActionLoading,
    reasonDuplicate, setReasonDuplicate,
    isLoadingAdressPhysicalCard, setLoadingAdressPhysicalCard,
    actionActiveBonCartObj, setActionActiveBonCartObj,
    imprestDetails, setImprestDetails,
    page, setPage
  };
};

export default useCustomHook;
